import { TextField, TextFieldProps } from "@mui/material";
import React from "react";
import { InputButtonGroup } from "ui/Scripts/source/components/framework/Button/InputButtonGroup";

interface TextFieldButtonFileInput {
    name?: string;
    accept?: string;
    multiple?: boolean;
    onChange: (files: File[]) => void;
}

interface TextFieldButton {
  label: string;
  hidden?: boolean;
  fileInput?: TextFieldButtonFileInput;
  startIcon?: React.ReactNode;
  onClick: (event) => void;
}

type TextFieldWithButtonGroupProps = TextFieldProps & {
    showButtons?: boolean;
    buttons: TextFieldButton[];
};

export const TextFieldWithButtonGroup = ({
    buttons,
    showButtons = true,
    ...props
}: TextFieldWithButtonGroupProps) => {
    return (
        <TextField
            size="small"
            fullWidth
            InputProps={{
                endAdornment: showButtons
                    ? <InputButtonGroup showButtons={true} buttons={buttons} />
                    : undefined,
            }}
            {...props}
        />
    );
};
